// extracted by mini-css-extract-plugin
export var TableOfContents = "TableOfContents-module--TableOfContents--LjiFq";
export var AnchorLinkSection = "TableOfContents-module--AnchorLinkSection--26p-u";
export var AnchorList = "TableOfContents-module--AnchorList--1jw3o";
export var LinkText = "TableOfContents-module--LinkText--1kS9N";
export var ActiveLinkText = "TableOfContents-module--ActiveLinkText--1OmL7";